module.exports = __webpack_public_path__ + "media/images/banner/kickstarter/food_book_banner_h2_v2-33c1caad250566b577a3cdbd2e5326f6.jpeg";